import {
 unref, ComputedRef, Ref, SetupContext,
} from 'vue';
import { IReturnProductType } from '@ve/pages/hotel/types';
import getCriteriaByRoomDate from '../services/getCriteriaByRoomDate';
import { IRoomCategories } from '../types';

export default function (props:
    {
        products: Ref<IReturnProductType[]>
        currentTakenCategory: ComputedRef<IRoomCategories | undefined>
    }, { emit }: SetupContext) {
    const { products, currentTakenCategory } = props;

    const openDescriptionDialog = () => {
        emit('openDescriptionDialog', unref(products));
    };

    const clickProductFirstHandler = (product: IReturnProductType) => {
        const isCurrentCategoryTaken = unref(currentTakenCategory);
        const currentTakenProductType = unref(currentTakenCategory)?.productType;
        const takenCriteriaRoom = getCriteriaByRoomDate(product);
        if (isCurrentCategoryTaken && product.type === currentTakenProductType) {
            emit('deleteRoomCategory', takenCriteriaRoom);
            return;
        }
        if (isCurrentCategoryTaken && product.type !== currentTakenProductType) {
            emit('updateRoomCategory', takenCriteriaRoom, product.type);
            return;
        }
        emit('addRoomCategory', takenCriteriaRoom, product.type);
    };

    return {
        openDescriptionDialog,
        clickProductFirstHandler,
    };
}